var singleton;


const init = function(store) {
  singleton = store;
  return singleton;
};

const get = function() {
  if (!singleton) {
    throw new Error('You must call `init` on appglobal singleton before calling `get`');
  }
  return singleton;
};



export { get, init };
export default { get, init };
